let sequence;

/**
 * 다음 고유번호 획득
 * @returns {string}
 */
export function getNextSequence() {
    if (sequence === undefined) {
        sequence = new Date().getTime();
    }

    return '' + sequence++
}

/**
 * 수동으로 초기 값 지정
 * @param value
 */
export function setSequence(value) {
    sequence = value;
}
